module.exports = __webpack_public_path__ + "static/img/r-2-1-icon.30d8723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-2/r-2-1-icon.png
// module id = 1Xfb
// module chunks = 0